/* eslint-disable consistent-return */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable no-restricted-globals */
import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import KinescopePlayer from '@kinescope/react-kinescope-player';
import { Divider, Stack, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import classes from './PlayerConspectDiv.module.css';
import {
  formatConspect,
  formatTextToHtml,
  formatTimeStart,
  getDefaultAlertProps,
  GetKineskopeUrlWithParams,
  selectTheme,
} from '../../utils/utils';
import {
  API_STATUS_PROBLEM,
  DARK_THEME,
  LIGHT_THEME,
  NORM_FONT_SIZE,
  WINDOW_H,
  WINDOW_V,
} from '../../constant/constants';
import Play1 from '../../image/Play_1.png';
import Play2 from '../../image/Play_2.png';
import { IAlertProps } from '../../interface/IAlertProps';
import { PlayerKinescopeDto } from '../../dto/PlayerKinescopeDto';
import { IApiResult } from '../../interface/IApiResult';
import { apiGetPlayerNew } from '../../service/apiGetPlayerNew';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import { DialogChatAi } from '../dialog/DialogChatAi';

declare global {
  interface Window {
    webkit?: any;
  }
}

interface Props {
  selectThemeFromMain: number;
  onChange: (e: any) => void;
}

const formatTextVideoLection = (text: string) => {
  const parts = text.split(/(`[^`]+`)/g);
  return parts.map((part, index) => {
    if (part.startsWith('`') && part.endsWith('`')) {
      return (
        <span
          key={index}
          style={{
            color: '#00C7D3',
            backgroundColor: '#00C7D333',
            fontWeight: 700,
            padding: '2px 4px',
            borderRadius: '4px',
            fontFamily: 'monospace',
          }}
        >
          {part.slice(1, -1)}
        </span>
      );
    }
    return <span key={index}>{part}</span>;
  });
};

export const PlayerConspectDiv: FunctionComponent<Props> = ({
  selectThemeFromMain,
  onChange,
}) => {
  const [playerKinescopeDto, setPlayerKiscopeDto] =
    useState<PlayerKinescopeDto>();
  const { accessToken, id, idOther, route, apiVersion, keyTitle, secureToken } =
    useParams();
  const [playerUrlReal, setPlayerUrlReal] = useState(id ?? '');
  const [playerUrl, setPlayerUrl] = useState(
    GetKineskopeUrlWithParams(playerUrlReal, playerKinescopeDto)
  );
  const videoContainerRef = useRef<HTMLDivElement>(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [conspect, setConspect] = useState<PlayerKinescopeDto[]>([]);

  const [curTheme, setCurTheme] = useState(DARK_THEME);
  const episodeRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});
  const [windowState, setWindowState] = useState(WINDOW_V);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [, setAlertProps] = useState<IAlertProps>(getDefaultAlertProps());

  const [selectedId2, setSelectedId2] = useState('');

  const playerRef = useRef<any>(null);
  const playVideo = async () => {
    if (playerRef.current) {
      try {
        await playerRef.current.play;
      } catch (error) {
        console.error('❌ Ошибка прокрутки:', error);
      }
    }
  };
  const [openDialogText, setOpenDialogText] = useState(false);

  const unmuteVideo = async () => {
    if (playerRef.current) {
      try {
        await playerRef.current.unmute();
      } catch (error) {
        console.error('❌ Ошибка включения звука:', error);
      }
    }
  };

  const seekVideo = async (seconds: number) => {
    if (playerRef.current) {
      try {
        await playerRef.current.seekTo(seconds);
        await unmuteVideo();
      } catch (error) {
        console.error('❌ Ошибка прокрутки:', error);
      }
    }
  };

  const setEpisode = (playerKinescopeSetup: PlayerKinescopeDto) => {
    setPlayerKiscopeDto(playerKinescopeSetup);
    seekVideo(playerKinescopeSetup.seek ?? 0);
    setSelectedId2(playerKinescopeSetup.id ?? '');
  };

  const findEpizode = (seconds: number) => {
    for (let i = 0; i < conspect.length; i += 1) {
      if (conspect[i] !== undefined) {
        const secondSeek = conspect[i].seek ?? 0;
        const durationSeek = conspect[i].duration ?? 0;
        let secondSeekNext = 36000;
        if (i < conspect.length - 1) {
          secondSeekNext = conspect[i + 1].seek ?? 0;
        }
        if (seconds > secondSeek && seconds < secondSeekNext) {
          setPlayerKiscopeDto(conspect[i]);
          const selectedId = conspect[i].id;
          if (
            selectedId &&
            episodeRefs.current[selectedId] &&
            selectedId !== playerKinescopeDto?.id
          ) {
            setSelectedId2(selectedId);
            episodeRefs.current[selectedId]?.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        }
      }
    }
  };

  useEffect(() => {
    setCurTheme(selectThemeFromMain ?? LIGHT_THEME);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectThemeFromMain]);

  useEffect(() => {
    setWindowWidth(window.innerWidth);
    let cnt = WINDOW_V;
    if (window.innerWidth > window.innerHeight) {
      cnt = WINDOW_H;
    }
    setWindowState(cnt);
  }, []);

  useEffect(() => {
    if (!selectedId2) return;

    // Задержка для полного расчета layout после поворота
    const timeoutId = setTimeout(() => {
      const element = episodeRefs.current[selectedId2];
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }, 100); // Даем время на пересчет layout'а

    return () => clearTimeout(timeoutId);
  }, [windowState, selectedId2]);

  const handlerChange = () => {
    let cnt = WINDOW_V;
    if (window.innerWidth > window.innerHeight) {
      cnt = WINDOW_H;
    }
    setWindowState(cnt);
    setWindowWidth(window.innerWidth);
  };

  const handleTimeUpdate = (currentTime: any) => {
    findEpizode(currentTime.currentTime);
  };

  const getPlayerNewNew = async () => {
    const apiResult: IApiResult = await apiGetPlayerNew(id ?? '');
    if (apiResult.isSuccess) {
      const conspectPlayer = formatConspect(apiResult.data, 'player');
      setConspect(conspectPlayer.conspectPlayer);
      setEpisode(conspectPlayer.conspectPlayer[0]);
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
  };

  useEffect(() => {
    window.addEventListener('resize', handlerChange, false);
    return () => {
      window.removeEventListener('resize', handlerChange, false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (id !== undefined) {
      getPlayerNewNew();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (!videoContainerRef.current) return;

    let rafId: number | null = null;

    const resizeObserver = new ResizeObserver((entries) => {
      // Отменяем предыдущий запрос анимации
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
      }

      // Обновляем состояние в следующем кадре анимации
      rafId = requestAnimationFrame(() => {
        for (const entry of entries) {
          setContainerWidth(entry.contentRect.width);
        }
      });
    });

    resizeObserver.observe(videoContainerRef.current);

    return () => {
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
      }
      resizeObserver.disconnect();
    };
  }, []);

  const chooseTypeColorTheme = (colorType: number) => {
    setCurTheme(colorType);
    let colorBody = '#FFFFFF';
    if (colorType === DARK_THEME) {
      colorBody = '#1D2228';
    }
    document.body.style.background = colorBody;
    onChange(colorType);
    handleClose();
  };

  const [fontSize, setFontSize] = useState(NORM_FONT_SIZE);

  const chooseTextSizeFont = (sizeFont: string) => {
    setFontSize(sizeFont);
    handleClose();
  };

  const [nativeTopInset, setNativeTopInset] = useState(0);

  useEffect(() => {
    const handleVariableChange = () => {
      const rootStyles = getComputedStyle(document.documentElement);
      const topInset = rootStyles
        .getPropertyValue('--host-nav-overlap-top')
        .trim();
      const numericValue = parseInt(topInset, 10) || 0;
      setNativeTopInset(numericValue);
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'style') {
          handleVariableChange();
        }
      });
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style'],
    });

    handleVariableChange();

    const handleResize = () => {
      handleVariableChange();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div
      style={{
        userSelect: 'none',
        background: selectTheme('#E5EAED;#1D2228', curTheme, -1),
      }}
      className={classes.myDiv4}
    >
      <div
        className={
          windowState === WINDOW_V ? classes.container : classes.container2
        }
      >
        <div
          ref={videoContainerRef}
          className={windowState !== WINDOW_V && classes.containerVideo}
          style={{
            paddingTop:
              windowState === WINDOW_V
                ? 'var(--host-nav-overlap-top, 0px)'
                : '0px',
            paddingLeft:
              windowState !== WINDOW_V
                ? 'var(--host-nav-overlap-top, 0px)'
                : '0px',
          }}
        >
          <div
            style={{
              width:
                windowState === WINDOW_V
                  ? '100%'
                  : `calc(100% - 10px - var(--host-nav-overlap-top, 0px))`,
              marginRight: windowState !== WINDOW_V ? '10px' : '0px',
              height:
                windowState === WINDOW_V
                  ? (windowWidth * 9) / 16
                  : ((containerWidth - 10 - nativeTopInset) * 9) / 16,
            }}
            className={classes.divVideo}
          >
            <div
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
                borderRadius: windowState !== WINDOW_V ? '10px' : '0px', // ← добавляем скругление
                overflow: 'hidden',
              }}
            >
              <KinescopePlayer
                ref={playerRef}
                onReady={unmuteVideo}
                muted={false}
                videoId={playerUrl}
                onTimeUpdate={handleTimeUpdate}
                playsInline // Для iOS
              />
            </div>
          </div>
        </div>
        <div
          style={{
            background: selectTheme('#FFFFFF;#1D2228', curTheme, -1),
          }}
          className={classes.divVideoList}
        >
          <Stack
            spacing={0}
            style={{
              userSelect: 'none',
              background: selectTheme('#FFFFFF;#1D2228', curTheme, -1),
            }}
            paddingTop={
              windowState !== WINDOW_V
                ? 'var(--host-nav-overlap-top, 0px)'
                : '0px'
            }
            marginTop={windowState === WINDOW_V ? '0px' : '0px'}
          >
            {conspect?.map((item, index) => (
              <Stack>
                <Stack
                  ref={(el) => {
                    if (item.id) {
                      episodeRefs.current[item.id] = el;
                    }
                  }}
                  key={item.id}
                  spacing={0}
                  paddingTop="10px"
                  paddingBottom="10px"
                  paddingLeft="14px"
                  paddingRight="20px"
                  style={{
                    scrollMarginTop:
                      windowState !== WINDOW_V
                        ? 'var(--host-nav-overlap-top, 0px)'
                        : '0px',
                    background: selectTheme(
                      playerKinescopeDto?.id === item.id
                        ? '#00C7D333;#00C7D333'
                        : '#FFFFFF;#1D2228',
                      curTheme,
                      -1
                    ),
                    borderLeft: `${
                      playerKinescopeDto?.id === item.id
                        ? '6px solid #00C7D3'
                        : '6px solid transparent'
                    }`,
                  }}
                  onClick={() => setEpisode(item)}
                >
                  <Stack direction="row" justifyContent="space-between">
                    <Stack direction="column">
                      <Typography
                        style={{
                          fontFamily: 'Roboto',
                          fontSize,
                          overflow: 'auto',
                          fontWeight: 400,
                          textAlign: 'left',
                          color: selectTheme(
                            '#00000080;#FFFFFF80',
                            curTheme,
                            -1
                          ),
                        }}
                        component="text"
                      >
                        {formatTimeStart(item.seek ?? 0)}
                      </Typography>
                      <Typography
                        style={{
                          fontFamily: 'Roboto',
                          fontSize,
                          overflow: 'auto',
                          fontWeight: 700,
                          textAlign: 'left',
                          color: selectTheme('#000000;#FFFFFF', curTheme, -1),
                        }}
                        component="text"
                      >
                        {formatTextVideoLection(item.title ?? '')}
                      </Typography>
                    </Stack>
                    <Stack onClick={() => setEpisode(item)}>
                      <img
                        alt=""
                        width="44px"
                        height="30px"
                        src={playerKinescopeDto?.id === item.id ? Play1 : Play2}
                      />
                    </Stack>
                  </Stack>
                  <Typography
                    style={{
                      fontFamily: 'Roboto',
                      fontSize,
                      overflow: 'auto',
                      fontWeight: '400',
                      textAlign: 'left',
                      color: selectTheme('#000000;#FFFFFF', curTheme, -1),
                    }}
                    component="div"
                  >
                    <div
                      style={{
                        whiteSpace: 'pre-line',
                      }}
                      dangerouslySetInnerHTML={{
                        __html: formatTextToHtml(item.text ?? ''),
                      }}
                    />
                  </Typography>
                </Stack>
                <Stack padding="10px">
                  {index !== conspect.length - 1 && (
                    <Divider orientation="horizontal" />
                  )}
                </Stack>
              </Stack>
            ))}
          </Stack>
        </div>
      </div>

      <DialogChatAi
        dto={conspect}
        open={openDialogText}
        fontSize={fontSize}
        curTheme={curTheme}
        onClose={() => setOpenDialogText(false)}
      />
    </div>
  );
};
